import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { AppService } from '../../utils/services/app.service';
import { ApiService } from '../../utils/services/api.service'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  public loginForm: FormGroup;
  public isAuthLoading = false;
  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.renderer.addClass(document.querySelector('app-root'), 'login-page');
    this.loginForm = new FormGroup({
      email: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
    });
  }

  async login() {
    if (this.loginForm.valid) {
      const testBy = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let isValid = testBy.test(this.loginForm.get("email").value.toLowerCase());
      if(!isValid) {
        this.toastr.error('Invalid Email Address');
        return false;
      }
      this.isAuthLoading = true;
      let loginData = {
        email: this.loginForm.get("email").value,
        password: this.loginForm.get("password").value
      };
      await this.apiService.onLogin(JSON.stringify(loginData)).subscribe((result: any) => {
        // console.log(result);
        if (result.success) {
          this.isAuthLoading = false;
          this.toastr.success(result.message);
          this.appService.login(result);
        } else {
          this.isAuthLoading = false;
          this.toastr.error(result.message);
        }
      });
    } else {
      this.toastr.error('Please Enter Email/Password');
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
  }
}
